import React, { useRef } from 'react';

import './CandlestickTileChart.scss';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext';
import { scaleLinear } from 'd3-scale';
import { styleConstants as tileStyleConstants } from 'widgets/tiles/components/styles/variables.module.constants';
import { TileTimeSeriesChart } from 'widgets/tiles/components/tile/TileTimeSeriesChart';
import { extentLinear } from '@d3fc/d3fc-extent';
import { CandlestickTileData } from 'widgets/candlestickTile/candlestickTileData';
import { candlestickTilesSeries } from 'widgets/candlestickTile/components/chart/series/candlestickTileSeries';
import { PriceTimeDataTimeSeriesItem } from 'widgets/candlestickTile/store/stream/PriceStreamState';

export interface CandlestickTileChartProps {
    chartKey: string;
    data: CandlestickTileData;
    onClick: (time: number | undefined) => void;
}

export function CandlestickTileChart(props: CandlestickTileChartProps) {
    const {
        data: { timeSeries, startTime, endTime, breaksInTrading },
        onClick,
        chartKey,
    } = props;

    const height =
        tileStyleConstants.tileHeight -
        tileStyleConstants.tileWidgetToolbarHeight -
        tileStyleConstants.tileWidgetToolbarMarginTop;

    const yExtent = extentLinear()
        .accessors([
            (a: PriceTimeDataTimeSeriesItem) => a.low,
            (a: PriceTimeDataTimeSeriesItem) => a.high,
        ])
        .pad([0.1, 0.1]);
    const yScaleRef = useRef(scaleLinear());
    const yDomain = yExtent(timeSeries);
    yScaleRef.current.domain(yDomain);

    return (
        <div className="CandlestickTileChart flippable">
            <XAxisContextProvider
                timeSeriesChartWidth={tileStyleConstants.tileWidth}
                startTime={startTime}
                endTime={endTime}
                breaks={breaksInTrading}
                rangeLabels={[]}
                timeLineLabels={[]}
                suppressTimeLine={true}
            >
                <TileTimeSeriesChart
                    id={`CandlestickTileTimeSeriesChart-${chartKey}`}
                    height={height}
                    data={timeSeries}
                    series={candlestickTilesSeries}
                    displayXAxis={true}
                    yScale={yScaleRef.current}
                    yTicks={0}
                    onChartClick={onClick}
                />
            </XAxisContextProvider>
        </div>
    );
}
